import React from 'react';

import { BaseIconProps } from '.';

export const MapPointer = ({ fill }: BaseIconProps) => {
  return (
    <g transform="matrix(53.993475,0,0,53.993475,162.04568,0)">
      <path
        d="M 6.213,19.623 C 4.384,17.361 0,10.96 0,7 a 7,7 0 1 1 14,0 c 0,3.958 -4.384,10.359 -6.213,12.622 a 1.011,1.011 0 0 1 -1.575,0 z"
        fill={fill}
      />
      <ellipse
        cx="3.1300001"
        cy="3.1370001"
        rx="3.1300001"
        ry="3.1370001"
        transform="translate(3.913,3.921)"
        fill="#ffffff"
      />
    </g>
  );
};
